"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _ActionStore2 = require("../../../../higher-order/ActionStore");

var _AmortizationTableModel = _interopRequireDefault(require("../AmortizationTableModel"));

var _isNaN = _interopRequireDefault(require("lodash/isNaN"));

var _isNull = _interopRequireDefault(require("lodash/isNull"));

var _extend = _interopRequireDefault(require("lodash/extend"));

var _class, _descriptor, _descriptor2, _descriptor3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var ImpactCalculatorStore = (_class = /*#__PURE__*/function (_ActionStore) {
  _inherits(ImpactCalculatorStore, _ActionStore);

  var _super = _createSuper(ImpactCalculatorStore);

  function ImpactCalculatorStore(props, dispatcher) {
    var _this;

    _classCallCheck(this, ImpactCalculatorStore);

    _this = _super.call(this, dispatcher);

    _initializerDefineProperty(_assertThisInitialized(_this), "invalidMonthlyPayment", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "extraPayment", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "loan", _descriptor3, _assertThisInitialized(_this));

    _this.extraPayment = props.extraPayment || 200;
    _this.loan = props.loan || {
      rate: 5,
      balance: 35000,
      term: 120,
      monthlyPayment: 371.23
    };
    return _this;
  }

  _createClass(ImpactCalculatorStore, [{
    key: "stats",
    get: function get() {
      var amortization = new _AmortizationTableModel.default(this.loan);
      amortization.applyExtraPaymentAfter(0, this.extraPayment);
      var defaultInterestPaid = amortization.getDefaultInterestPaid();
      var totalInterestPaid = amortization.getTotalInterestPaid();
      var extraPaymentTerm = amortization.getEndOfTerm(); // extraPaymentTerm = # of months paying principal, but monthlyBalances are tracked *after* payment has been made
      // so an extraPaymentTerm = 90 means principal was paid off in monthlyBalances[89], which means the principal going into that
      // month can be found at monthlyBalances[88]

      var lastMonthPrincipal = amortization.getPrincipalAfterMonth(extraPaymentTerm - 2);
      var lastMonthInterest = amortization.getInterestPaidInMonth(extraPaymentTerm - 2);
      var principalSavings = this.extraPayment * (extraPaymentTerm - 1) // assume that anything remaining the last month was first paid but the monthly payment, and only what was remaining
      // after that can be attributed to the extra payment
      + Math.max(0, lastMonthPrincipal + lastMonthInterest - this.loan.monthlyPayment);
      return {
        defaultInterestPaid: defaultInterestPaid,
        totalInterestPaid: totalInterestPaid,
        extraPaymentTerm: extraPaymentTerm,
        principalSavings: principalSavings,
        defaultYearlyCostRemaining: amortization.getDefaultCostRemainingByYear(),
        yearlyCostRemaining: amortization.getCostRemainingByYear(),
        defaultMonthlyPrincipal: amortization.getDefaultPrincipalAfterEachMonth(),
        monthlyPrincipal: amortization.getPrincipalAfterEachMonth()
      };
    }
  }, {
    key: "updateExtraPayment",
    value: function updateExtraPayment(e) {
      this.extraPayment = e.data.value;
    }
  }, {
    key: "updateLoanAndEstimateTerm",
    value: function updateLoanAndEstimateTerm(e) {
      var loan = (0, _extend.default)({}, this.loan);
      loan[e.data.key] = e.data.value;
      var amortization = new _AmortizationTableModel.default(loan);
      var term = amortization.getEstimatedTerm();

      if (!(0, _isNull.default)(term) && !(0, _isNaN.default)(term)) {
        this.loan = (0, _extend.default)(loan, {
          term: term
        });
        this.invalidMonthlyPayment = false;
      } else {
        this.loan = loan;
        this.invalidMonthlyPayment = true;
      }
    }
  }, {
    key: "updateLoanAndEstimateMonthlyPayment",
    value: function updateLoanAndEstimateMonthlyPayment(e) {
      var loan = (0, _extend.default)({}, this.loan);
      loan[e.data.key] = e.data.value;
      var amortization = new _AmortizationTableModel.default(loan);
      var monthlyPayment = amortization.getMonthlyPayment();
      this.loan = (0, _extend.default)(loan, {
        monthlyPayment: monthlyPayment
      });
    }
  }]);

  return ImpactCalculatorStore;
}(_ActionStore2.ActionStore), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "invalidMonthlyPayment", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "extraPayment", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "loan", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "stats", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "stats"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateExtraPayment", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class.prototype, "updateExtraPayment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateLoanAndEstimateTerm", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class.prototype, "updateLoanAndEstimateTerm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateLoanAndEstimateMonthlyPayment", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class.prototype, "updateLoanAndEstimateMonthlyPayment"), _class.prototype)), _class);
exports.default = ImpactCalculatorStore;